import axios from 'axios';
import { SelfServiceApi } from '@bookingkit/api-v4';
import { ILogger } from '@/Contracts';
import { SelfService } from '@/Services/BKAPI/SelfService';
import { makeOnReject, onFullFilled } from '@/Services/BKAPI/Interceptors';
import { API_V4_BASE_URL } from '@/bootstrap/environment';

export default ({
    logger,
    authToken,
}: {
    logger: ILogger;
    authToken?: string;
}) => {
    const axiosInstance = axios.create({});
    axiosInstance.interceptors.response.use(onFullFilled, makeOnReject(logger));
    return {
        selfService: new SelfService(
            new SelfServiceApi(undefined, API_V4_BASE_URL, axiosInstance),
            authToken,
            logger
        ),
    };
};
